<template>
  <div>
    <div class="jumbotron">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item"><a href="#/apps">Apps</a></li>
        <li class="breadcrumb-item active">Scheduled Functions {{ app.name }}</li>
      </ol>
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#sf" ref="sfStatsRef">Scheduled Functions</a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade active show" id="sf">
        <div class="row">
          <div class="col">
            <div>
              <div v-if="scheduledFunctions.length > 0">
                <vue-good-table title="Scheduled Functions" :columns="functionColumns" :rows="scheduledFunctions"
                  :sort-options="{
                    enabled: true,
                    initialSortBy: { field: 'unit', type: 'asc' }
                  }" :search-options="{ enabled: true }" :paginationOptions="{ enabled: true }"
                  styleClass="vgt-table striped bordered table-hover">
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'schedule'">{{ props.row.schedule }}</span>
                    <span v-if="props.column.field == 'unit'">{{ props.row.unit }}</span>
                    <span v-if="props.column.field == 'event'">{{ props.row.event }}</span>
                    <span v-if="props.column.field == 'state'">{{ props.row.state }}</span>
                    <span v-if="props.column.label == 'Actions'">
                      <button type="button" class="btn btn-sm btn-info"
                        v-on:click="btnToggleScheduledFunction(props.row.unit, props.row.event, props.row.state)">
                        <i class="fas fa-edit" aria-hidden="true"></i> Toggle
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
              <div v-else>
                <strong>No Results found!</strong> No scheduled function cound be found for this app.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'
export default {
  components: {
    Loading
  },
  data: function () {
    return {
      app: null,
      scheduledFunctions: [],
      functionColumns: [
        {
          label: 'Schedule',
          field: 'schedule'
        },
        {
          label: 'Unit',
          field: 'unit',
          filterable: true
        },
        {
          label: 'Function',
          field: 'event',
          filterable: true
        },
        {
          label: 'State',
          field: 'state',
          filterable: true
        },
        {
          label: 'Actions',
          field: 'btn',
          html: true
        }
      ],
      sfLoading: false
    }
  },
  methods: {
    getCurrentScheduledFunctions: function () {
      let vm = this
      vm.$parent.loading = true
      vm.scheduledFunctions = []

      let config = {}
      let credentials = {}
      credentials['userName'] = vm.$parent.username
      credentials['password'] = vm.$parent.password
      config['credentials'] = credentials
      config['baseUrl'] = vm.$parent.environment.baseUrl
      config['appId'] = vm.app.id
      let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/get-scheduled-events/'
      vm.axios.post(endpoint, config)
        .then(function (response) {
          vm.scheduledFunctions = response.data
          vm.$parent.loading = false
        })
        .catch(function (error) {
          vm.$parent.loading = false
          let obj = {
            title: 'Error getting scheduled functions!',
            message: error.response.data,
            type: 'error'
          }
          vm.$Simplert.open(obj)
        })
    },
    btnToggleScheduledFunction: function (unit, event, state) {
      let vm = this
      let config = {}
      config['baseUrl'] = vm.$parent.environment.baseUrl
      config['appId'] = vm.app.id
      config['scheduledEvent'] = unit + ':' + event
      config['state'] = state
      let endpoint = vm.$parent.baseUrl + '/portal-backend/api/config/toggle-scheduled-event'
      vm.$parent.loading = true
      vm.axios.post(endpoint, config)
        .then(function (response) {
          vm.$Simplert.open({ title: 'Success', message: response.data, type: 'success' })
          vm.$parent.loading = false
        })
        .catch(function (error) {
          vm.$parent.loading = false
          vm.$Simplert.open({ title: 'Error', message: error.response.data, type: 'error' })
        })
      vm.getCurrentScheduledFunctions()
    }
  },
  created () {
    let vm = this
    vm.$parent.apps.forEach(function (key) {
      if (key.id === vm.$route.params.appid) {
        vm.app = key
      }
    })
    vm.getCurrentScheduledFunctions()
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ScheduledFunctions.vue?4d943535